import type { Order } from '../../../types/apiResponse/order';

export const orderRowKey = (order: Order): string => order.row_key || JSON.stringify([
  order.history_only ? 'history' : 'order', order.CodigoEmpresa,
  order.history_only ? order.history_order_number : order.NumeroPedido, order.CodigoVendedor, order.CodigoCliente,
]);

export const operationalStatusLabel = (status: Order['operational_status'], english = false): string => {
  const labels = english
    ? {
      awaitingApproval: 'Awaiting approval',
      rejected: 'Rejected',
      processing: 'Processing',
      completed: 'Completed',
      error: 'Error',
      cancelled: 'Cancelled',
    }
    : {
      awaitingApproval: 'Aguardando aprovação',
      rejected: 'Rejeitado',
      processing: 'Em processamento',
      completed: 'Concluído',
      error: 'Erro',
      cancelled: 'Cancelado',
    };
  return status ? labels[status] : '—';
};
